module.exports = __webpack_public_path__ + "static/media/Tangela_gaussian2.6b9f8d27.png";